/**
 * Проверяет все обязательные поля позиции для передачи заказа на статус "На запуск"
 * @param {Object} position - объект позиции
 * @returns {Object} - объект с результатами валидации
 */
export function validatePositionForLaunch (position) {
  const errors = []

  const typeId = position.type?.id
  const shapeId = position.shape?.id

  // Проверяем все обязательные поля как при сохранении
  if (!position.article) {
    errors.push('Артикул')
  }

  if (!position.value) {
    errors.push('Количество')
  }

  if (!position.responsible?.id) {
    errors.push('Диспетчер производства')
  }

  if (!position.name) {
    errors.push('Наименование')
  }

  // Проверяем поля в зависимости от типа позиции и формы
  if (shapeId || !(typeId === 1 || typeId === 2)) {
    if (!position.d_wire) {
      errors.push('d проволоки')
    }

    if (!position.material?.id) {
      errors.push('Материал')
    }

    if (!position.sweep_length) {
      errors.push('Длина развертки')
    }

    // Проверяем поля в зависимости от типа позиции
    if (typeId === 1 || typeId === 2) {
      if (!shapeId) {
        errors.push('Вид пружины')
      }
    }

    if (!position.d_inner && [5, 9].includes(typeId)) {
      errors.push('D внутренний')
    }

    if (!position.d_inner_limit && [5, 9].includes(typeId)) {
      errors.push('Допуск по D внутр.')
    }

    if (!position.d_outer_1 && [1, 2, 3, 7, 8].includes(typeId)) {
      errors.push([1, 2, 7].includes(typeId) && shapeId !== 1 ? 'D1 больший' : 'D наружный')
    }

    if (!position.d_outer_1_limit && [1, 2, 3, 7, 8].includes(typeId)) {
      errors.push([1, 2, 7].includes(typeId) && shapeId !== 1 ? 'Допуск по D1 большему' : 'Допуск по D наруж.')
    }

    console.log(shapeId)
    if (!position.d_outer_2 && [1, 2, 7].includes(typeId) && shapeId !== 1) {
      errors.push('D1 меньший')
    }

    if (!position.d_outer_2_limit && [1, 2, 7].includes(typeId) && shapeId !== 1) {
      errors.push('Допуск по D1 меньшему')
    }

    if (!position.overall_length && typeId === 4) {
      errors.push('Габаритная длина изделия')
    }

    if (!position.body_length && ![4, 8].includes(typeId)) {
      errors.push('Длина тела (L0)')
    }

    if (!position.perpendicularity && typeId === 1) {
      errors.push('Перпендикулярность')
    }

    if (!position.step && [1, 7].includes(typeId)) {
      errors.push('Шаг (t)')
    }

    if (!position.step_limit && [1, 7].includes(typeId)) {
      errors.push('Допуск на шаг')
    }

    if (!position.number_turns && [1, 2, 3, 5, 9].includes(typeId)) {
      errors.push('Число рабочих витков (n)')
    }

    if (!position.number_full_turns && [7, 8].includes(typeId)) {
      errors.push('Число полных витков (n1)')
    }

    if (!position.turns_limit && [1, 2, 7, 8, 9].includes(typeId)) {
      errors.push('Допуск по виткам')
    }

    if (typeId === 2) {
      if (!position.length_by_hooks) {
        errors.push('Длина по зацепам')
      }
      if (!position.hook_type_1?.id) {
        errors.push('Тип зацепа 1')
      }
      if (!position.hook_type_2?.id) {
        errors.push('Тип зацепа 2')
      }
      if (!position.hook_length_1) {
        errors.push('Длина зацепа 1')
      }
      if (!position.hook_length_2) {
        errors.push('Длина зацепа 2')
      }
      if (!position.hook_orientation_1?.id) {
        errors.push('Ориентация зацепов')
      }
      if (!position.hook_gap_1) {
        errors.push('Зазор зацепа 1')
      }
      if (!position.hook_gap_1_limit) {
        errors.push('Допуск на зазор 1')
      }
      if (!position.hook_gap_2) {
        errors.push('Зазор зацепа 2')
      }
      if (!position.hook_gap_2_limit) {
        errors.push('Допуск на зазор 2')
      }
    }

    if ([3, 5].includes(typeId)) {
      if (!position.tap_length_1) {
        errors.push('Длина отвода 1')
      }
      if (!position.tap_length_2) {
        errors.push('Длина отвода 2')
      }
      if (!position.tap_length_1_limit) {
        errors.push('Допуск на длину отвода 1')
      }
      if (!position.tap_length_2_limit) {
        errors.push('Допуск на длину отвода 2')
      }
      if (!position.tap_angle && position.tap_angle !== 0) {
        errors.push('Угол м/у отводами и зацепом')
      }
      if (!position.winding_type?.id) {
        errors.push('Тип навивки')
      }
    }

    if (typeId === 7) {
      if (!position.number_turn_cylinder) {
        errors.push('Число витков на цилиндр')
      }
    }

    if (typeId === 8) {
      if (!position.gap) {
        errors.push('Зазор')
      }
      if (!position.gap_limit) {
        errors.push('Допуск на зазор')
      }
      if (!position.flatness?.id) {
        errors.push('Плоскостность')
      }
      if (!position.chamfer?.id) {
        errors.push('Фаска')
      }
      // if (!position.folds?.id) {
      //   errors.push('Загибы')
      // }
    }

    if ([1, 7].includes(typeId)) {
      if (!position.reference_turn_1?.id) {
        errors.push('Опорный виток 1')
      }
      if (!position.reference_turn_2?.id) {
        errors.push('Опорный виток 2')
      }
    }

    if (!position.winding_dir?.id && ![4, 5].includes(typeId)) {
      errors.push('Направление навивки')
    }

    // if (!position.tap_orientation && [9].includes(typeId)) {
    //   errors.push('Ориентация отводов')
    // }

    if (!position.body_length_limit && ![4, 8].includes(typeId)) {
      errors.push('Допуск по длине')
    }

    if (!position.hardness && typeId !== 9) {
      errors.push('Твердость')
    }

    if (!position.surface_treatment?.id) {
      errors.push('Поверхностная обработка')
    }

    if (!position.tests?.id) {
      errors.push('Испытания')
    }

    if (!position.probes && position.probes !== 0) {
      errors.push('Количество пробников')
    }

    if (!position.coating?.id) {
      errors.push('Покрытие')
    }

    if (!position.color?.id && !position.color_text) {
      errors.push('Цвет')
    }

    if (!position.comment) {
      errors.push('Комментарий для производства')
    }

    if (!position.note_otk) {
      errors.push('Комментарий для ОТК')
    }
  }

  return {
    isValid: errors.length === 0,
    errors
  }
}

/**
 * Проверяет все позиции заказа для передачи на статус "На запуск"
 * @param {Array} positions - массив позиций
 * @returns {Object} - объект с результатами валидации
 */
export function validatePositionsForLaunch (positions) {
  const allErrors = []

  positions.forEach((position) => {
    const validation = validatePositionForLaunch(position)
    if (!validation.isValid) {
      console.log(position.type.id, validation)
      allErrors.push(`Позиция ${position.sort},\n`)
    }
  })

  return {
    isValid: allErrors.length === 0,
    errors: allErrors
  }
}
